import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'

const DetergentsPageHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={() => navigate({ pathname: routes.detergentsImport.path, search: `is_insert=true` })}>
        {t('components.pages.detergents.list.buttonAction.importAdd')}
      </Menu.Item>
    </Menu>
  )

  return (
    <PageHeader
      ghost={false}
      title={t('components.pages.detergents.list.pageHeader.title')}
      extra={[
        <>
          <Dropdown.Button
            key="action"
            type="primary"
            icon={<DownOutlined />}
            overlay={menu}
            onClick={() => navigate(routes.createDetergent.path)}
          >
            {t('components.pages.detergents.list.pageHeader.new')}
          </Dropdown.Button>
        </>,
      ]}
    />
  )
}

DetergentsPageHeader.displayName = 'DetergentsPageHeader'
export default DetergentsPageHeader
